/* eslint-disable max-params */
/* eslint-disable one-var */
// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
import defaultimg from '@/assets/images/default.jpg';
import {
  queryInstanceDetails,
  queryMarkByFileInfoId,
  queryRecommendedImageList,
  querySameElementFileList
  // queryByMarkId
} from '../../../shared/api';
import OpenSeadragon from 'openseadragon';
import './js/OpenSeadragonHTMLelements';
import './js/openseadragon-canvas-overlay';
import $ from 'jquery';
import './index.scss';
const iiifPre = window.iiifApi;
const imgPre = window.ENV_IMG_PREURL_SRC;
export class PictureViewer {
  constructor(container, instanceId, fileInfoId, initialPage,isInitImg) {
    this.container = container;
    this.fileInfoId = fileInfoId;
    //  this.resourceId = resourceId;
    this.instanceId = instanceId;
    this.initialPage = initialPage || 0; // 当前图片索引
    this.iiif = undefined;
    // OpenSeadragonSelection
    this.selection = 'null';
    this.isInitImg = isInitImg;
    this.currentMarkId = '';
  }

  init(iiif) {
    let that = this;
    this.hEl = null;
    // 所有标记数据
    this.allMarksList = [];
    // // 当前分页数据
    // let currentMarksList = [];
    this.pageBase = {
      pageNum: 1, // 当前页数
      pageSize: 8, // 每页显示条数
      pages: null // 总页数
    };
    this.markpage = 0;
    this.markpage1 = 0;
    // openseadragon对象
    let viewer;
    // //  OpenSeadragonCanvasOverlay对象
    // let overlay;
    //  是否启用画笔工具
    let brushState = false;
    //  是否已有绘制完成的面
    let hasDrawed = false;
    //  绘制类型 line:线；surface:面
    // let drawType = 'line';
    //  当前取到的点的集合
    let clickPointArr = [];
    //  当前图片所属实例的概念code;
    // let conceptCode = '';
    // 实例详情
    this.instanceData = [];
    //   查询推荐数据分页
    this.current = 0;
    //   当前展示的页数
    this.currentShow = 1;
    // 推荐总页数
    this.tuijianpages = 1;
    //  推荐数据
    this.recommendData = [];
    //  标记音频是否播放完成
    this.audioEnded = true;
    // 初始化事件绑定
    this.onButtonsClick();
    // 获取图片详情信息
    // this.getInstanceDetail();
    //  页面初始化
    this.viewer = OpenSeadragon({
      element: this.container, // 容器id
      showNavigator: false, // 隐藏导航缩略图
      showNavigationControl: false, // 隐藏基础控件
      visibilityRatio: 1.0,
      sequenceMode: true, // 序列模式 多图情况
      // showReferenceStrip: true, // 多图水平滚动
      constrainDuringPan: true,
      // 是否显示前进后退按钮
      showSequenceControl: false,
			minZoomLevel: 0.2, // 最小缩放级别
			maxZoomLevel: 5, // 最大缩放级别
      gestureSettingsMouse: {
        clickToZoom: false, // 禁用点击缩放功能
        dblClickToZoom: false, // 禁用双击缩放功能
        scrollToZoom: true
      },
      initialPage: this.initialPage,
      tileSources: iiif
    });
    this.viewer.addHandler('page', function(data) {
      that.initialPage = data.page;
    });

    this.viewer.addHandler('open', () => {
      //  绘制所有标注
      that.drawAllMarks();
      //  绑定按钮组点击事件
      that.onPicButtonsClick();
    });

    //  对OpenSeadragon.Viewer#canvas element添加单击事件
    this.viewer.addHandler('canvas-click', function(event) {
      //  判断是否开启画笔工具
      if (brushState && !hasDrawed) {
        let webPoint = event.position;
        let viewportPoint = viewer.viewport.pointFromPixel(webPoint);
        let imagePoint = viewer.viewport.viewportToImageCoordinates(viewportPoint);
        //  判断当前是否重复取点
        const len = clickPointArr.filter((item) => item.x === imagePoint.x).length;
        if (len === 0) {
          clickPointArr.push(imagePoint);
        }
        // drawSurface('line');
      }
    });

    //  对OpenSeadragon.Viewer#canvas element添加双击事件
    this.viewer.addHandler('canvas-double-click', function(event) {
      //  判断是否开启画笔工具
      if (brushState && !hasDrawed) {
        // drawSurface('surface');
        $('.openseadragon-canvas').css('cursor', 'default');
        hasDrawed = true;
      }
    });

    // 获取OpenSeadragonHTMLelements对象;
    this.hEl = this.viewer.HTMLelements();
  }

  //  大图浏览按钮组事件绑定
  onPicButtonsClick() {
    //  放大
    $('#zoomIn').on('click', () => {
      this.viewer.viewport.zoomBy(1.5);
    });

    //  缩小
    $('#zoomOut').on('click', () => {
      this.viewer.viewport.zoomBy(0.5);
      this.viewer.viewport.applyConstraints();
    });

    //  切换模式(高度铺满/宽度铺满)
    $('#fitWh').on('click', () => {
      if ($('#fitWh').hasClass('full')) {
        this.viewer.viewport.fitVertically();
        $('#fitWh').removeClass('full');
      } else {
        this.viewer.viewport.fitHorizontally();
        $('#fitWh').addClass('full');
      }
    });

    //   //  打开或关闭取点模式
    $('#toggleClickBtn').click(function() {
      this.brushState = !this.brushState;
      if (this.brushState) {
        this.clickPointArr = [];
        $('#toggleClickBtn img')[0].src = '../../../img/icon-surface-active.png';
        $('.openseadragon-canvas').css('cursor', 'crosshair');
      } else {
        $('#toggleClickBtn img')[0].src = '../../../img/icon-surface.png';
        $('.openseadragon-canvas').css('cursor', 'default');
        // drawSurface('empty');
        this.hasDrawed = false;
      }
    });
  }

  // //  全局事件绑定
  onButtonsClick() {
    const th = this;
    //  查看标记搜索模块
    $('#search').on('click', () => {
      $('.viewer_menu').removeClass('closed');
      $('.img_info').hide();
      $('.mark_info').show();
      $('#asideClose').removeClass('hideCloseBtn');
      setTimeout(() => {
        $('#pic').addClass('showAside');
      }, 500);
    });
    //  查看图像详情内容
    $('#detail').on('click', () => {
      if (
        $('#detail')
          .attr('class')
          .includes('asideClose')
      ) {
        $('#pic').removeClass('showAside');
        $('.viewer_menu').addClass('closed');
        // $('#asideClose').addClass('hideCloseBtn');
        $('#detail').removeClass('asideClose');
      } else {
        $('.viewer_menu').removeClass('closed');
        $('.mark_info').hide();
        $('.img_info').show();
        // $('#asideClose').removeClass('hideCloseBtn');
        $('#detail').addClass('asideClose');
        setTimeout(() => {
          $('#pic').addClass('showAside');
        }, 500);
      }
    });
    //  关闭标记详情弹出框
    $('.close').click(function() {
      $('#playAudio')
        .removeClass('play fa-volume-down')
        .addClass('fa-volume-off');
      $('.markDetail').fadeOut();
      $('#markAudio')[0].pause();
      th.audioEnded = true;
      // 显示所有标记
      $('.markOverlay').css('display','block');
      // 清除高亮显示区域
      th.clearHighlight();
    });
    //  下一页相同元素
    $('.knowledgeitem2 .next').click(function() {
      let elements = $('.knowledgeitem2 .item');

      if (th.markpage1 < elements.length - 2) {
        th.markpage1 = th.markpage1 + 1;
        // console.log(th.markpage1, 138 * th.markpage1);
        for (let i = 0; i < elements.length; i++) {
          elements.eq(i).css('transform', 'translateX(' + -(138 * th.markpage1) + 'px)');
        }
        if (th.markpage1 === elements.length - 2) {
          $('.knowledgeitem2 .next').addClass('disable');
        }
      }

      $('.knowledgeitem2 .prev').removeClass('disable');
    });
    //  上一页相同元素
    $('.knowledgeitem2 .prev').click(function() {
      let elements = $('.knowledgeitem2 .item');
      if (th.markpage1 > 0) {
        th.markpage1 = th.markpage1 - 1;
        // console.log(th.markpage1, 138 * th.markpage1);
        for (let i = 0; i < elements.length; i++) {
          elements.eq(i).css('transform', 'translateX(' + -(138 * th.markpage1) + 'px)');
        }
        if (th.markpage1 === 0) {
          $('.knowledgeitem2 .prev').addClass('disable');
        }
      }
      $('.knowledgeitem2 .next').removeClass('disable');
    });
    //  下一页知识扩展
    $('.knowledgeitem1 .next').click(function() {
      let elements = $('.knowledgeitem1 .item');

      if (th.markpage < elements.length - 2) {
        th.markpage = th.markpage + 1;
        // console.log(th.markpage, 138 * th.markpage);
        for (let i = 0; i < elements.length; i++) {
          elements.eq(i).css('transform', 'translateX(' + -(138 * th.markpage) + 'px)');
        }
        if (th.markpage === elements.length - 2) {
          $('.knowledgeitem1 .next').addClass('disable');
        }
      }

      $('.knowledgeitem1 .prev').removeClass('disable');
    });
    //  上一页知识扩展
    $('.knowledgeitem1 .prev').click(function() {
      let elements = $('.knowledgeitem1 .item');
      if (th.markpage > 0) {
        th.markpage = th.markpage - 1;
        // console.log(th.markpage, 138 * th.markpage);
        for (let i = 0; i < elements.length; i++) {
          elements.eq(i).css('transform', 'translateX(' + -(138 * th.markpage) + 'px)');
        }
        if (th.markpage === 0) {
          $('.knowledgeitem1 .prev').addClass('disable');
        }
      }

      $('.knowledgeitem1 .next').removeClass('disable');
    });
    //  获取下一页推荐数据
    $('.relativeSlideRight').click(function() {
      if (th.tuijianpages === th.currentShow + 1) {
        $('.relativeSlideRight').addClass('disable');
      }
      if (th.currentShow === th.current) {
        th.getRecommendInstance(th.current + 1);
      } else {
        th.currentShow++;
        let containerWidth = $('.relativeSlideContent').width();
        let elements = $('.relativeCultureBox');
        for (let i = 0; i < elements.length; i++) {
          let translateX = th.getTransformVal(elements.eq(i))[4];
          elements.eq(i).css('transform', 'translateX(' + (translateX - containerWidth) + 'px)');
        }
        $('.relativeSlideLeft').removeClass('disable');
      }
    });
    //  获取上一页推荐数据
    $('.relativeSlideLeft').click(function() {
      if (th.currentShow > 1) {
        th.currentShow--;
        $('.relativeSlideRight').removeClass('disable');
        let containerWidth = $('.relativeSlideContent').width();
        let elements = $('.relativeCultureBox');
        for (let i = 0; i < elements.length; i++) {
          let translateX = th.getTransformVal(elements.eq(i))[4];
          elements.eq(i).css('transform', 'translateX(' + (translateX + containerWidth) + 'px)');
        }
        if (th.currentShow === 1) {
          $('.relativeSlideLeft').addClass('disable');
        }
      }
    });
  }

  //  获取元素的transform属性
  getTransformVal(el) {
    let str = el.css('transform');
    if (str === 'none') {
      return [1, 0, 0, 1, 0, 0];
    }
    let reg = /matrix.(((-)?([0-9]+.)?\d+([, ]+)?){6})./g;
    let arr = reg.exec(str);
    let newArr = arr[1].split(/[, ]+/g);
    newArr.forEach((val, i) => {
      // eslint-disable-next-line radix
      newArr[i] = parseInt(val);
    });
    return newArr;
  }

  // 获取当前图片的所有标注信息，并在图片上绘制
  drawAllMarks() {
    // // 关闭标注详细信息弹框
    // if ($('.markActive').length > 0) {
    //   $('.close').trigger('click');
    // }
    // // 清除原始标注信息
    // for (let i = 0; i < this.allMarksList.length; i++) {
    //   const id = 'mark_' + this.allMarksList[i].imageMarkId;
    //   this.hEl.removeElementById(id);
    // }
    // 查询当前图片的所有标记信息
    queryMarkByFileInfoId(this.fileInfoId[this.initialPage]).then((res) => {
      // 先清除之前标记
      // if (this.allMarksList.length > 0) {
      for (let i = 0; i < this.allMarksList?.length; i++) {
        this.hEl.removeElementById(`mark_${this.allMarksList[i].imageMarkId}`);
      }
      // }
      if (res?.length > 0) {
        this.allMarksList = res;
        let listhtml = '';
        $('#marklist').css('display', 'block');
        for (let i = 0; i < this.allMarksList.length; i++) {
          listhtml += `<div class="list-item"><span>${this.allMarksList[i].markName}</span></div>`;
          // 大图标记渲染
          const item = this.allMarksList[i];
          const rect = {
            x: parseFloat(item.position.split(',')[0]),
            y: parseFloat(item.position.split(',')[1]),
            cx: parseFloat(item.point.split(',')[0]),
            cy: parseFloat(item.point.split(',')[1]),
            width: parseFloat(item.width),
            height: parseFloat(item.height),
            text: item.markName,
            id: item.imageMarkId
          };
          this.addLayer(rect, i);
          // 获取标注点集合
          if(item['points'] && item['points'] != '[]'){
            item['points'] = JSON.parse(item['points']);
          }else{
            item['points'] = this.getPoints(rect.x,rect.y,rect.width,rect.height);
          }
        }
        // 右侧标记列表渲染
        $('#marklist .scroll').html(listhtml);
        const zoom = this.viewer.viewport.getZoom();
        this.viewer.viewport.zoomTo(zoom + 0.0001);
      } else {
        $('#marklist').css('display', 'none');
        // // 没有的话清除之前标记
        // for (let i = 0; i < this.allMarksList.length; i++) {
        //   this.hEl.removeElementById(`mark_${this.allMarksList[i].imageMarkId}`);
        // }
        this.allMarksList = [];
      }
      let th = this;
      // 侧边列表点击展开标记
      $('.list-item').on('click', function() {
        // console.log($(this).index(), $('.markOverlay').eq($(this).index()));
        // console.log($('.markOverlay').eq($(this).index())[0].id);
        // 关闭标注详细信息弹框
        let delayTime = 0;
        // console.log('active length:  ' + $('.markActive').length);
        // if ($('.markActive').length > 0) {
        //   $('.close').trigger('click');
        //   delayTime = 3000;
        // }
        $(this).addClass('active').siblings().removeClass('active');
        setTimeout(() => {
          $('.markActive').removeClass('markActive');
          const index = $(this).index();
          const id = th.allMarksList[index].imageMarkId;
          const overlayEle = $('#mark_'+id).parent();
          $('#mark_'+id).addClass('markActive');
          th.markClick(id,overlayEle);
        },delayTime);
      });
    });
  }

  // 绘制标注矩形框
  addLayer(rect, i) {
    if (rect) {
      let markElement = document.createElement('div');
      let id = 'mark_' + rect.id;
      markElement.className = 'markOverlay';
      markElement.id = id;
      markElement.setAttribute('index', i);
      let ele = {
        id: id,
        element: markElement,
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height
      };
      let circlePx = 0;
      let circlePy = 0;
      if (rect.cx) {
        circlePx = ((rect.cx - rect.x) / rect.width) * 100;
        circlePy = ((rect.cy - rect.y) / rect.height) * 100;
      }
      this.hEl.addElement(ele);
      let divEle = this.hEl.getElementById(id).element.getElementsByClassName('markOverlay')[0];
      // divEle.innerHTML =
      //   '<span class="markName">' + rect.text + '</span>' + '<div class="circle"></div>';
      divEle.innerHTML =
        '<div class="box"></div>' +
        '<span class="markName">' +
        rect.text +
        '</span>' +
        '<div class="circle"></div>';
      divEle.getElementsByClassName('circle')[0].title = rect.text;
      // 设置标记定位坐标
      divEle.getElementsByClassName('circle')[0].style.left = circlePx + '%';
      divEle.getElementsByClassName('circle')[0].style.top = circlePy + '%';
      divEle.getElementsByClassName('markName')[0].style.left = circlePx + '%';
      divEle.getElementsByClassName('markName')[0].style.top = circlePy + '%';
      const th = this;
      $('#pic .circle').on('click', function() {
        const index = $(this)
          .parent()[0]
          .getAttribute('index');
        $('#marklist .scroll div')
          .eq(index)
          .addClass('active')
          .siblings()
          .removeClass('active');
        let overlayEle = $(this)
          .parent()
          .parent();
        let id = $(this)
          .parent()
          .attr('id')
          .substr(5);
        $('.markActive').removeClass('markActive');
        $(this)
          .parent()
          .addClass('markActive');
        th.markClick(id, overlayEle);
        // $('.markDetail').fadeOut();
      });
      $('#pic .markName').on('click', function() {
        const index = $(this)
          .parent()[0]
          .getAttribute('index');
        $('#marklist .scroll div')
          .eq(index)
          .addClass('active')
          .siblings()
          .removeClass('active');
        let overlayEle = $(this)
          .parent()
          .parent();
        let id = $(this)
          .parent()
          .attr('id')
          .substr(5);
        $('.markActive').removeClass('markActive');
        $(this)
          .parent()
          .addClass('markActive');
        th.markClick(id, overlayEle);

        // $('.markDetail').fadeOut();
      });
    }
  }

  // // // 标注点击事件
  // markClick(id, overlayEle) {
  //   let data = this.allMarksList.filter((item) => item.imageMarkId === id)[0];
  //   //  设置缩放动画时间
  //   this.viewer.viewport.zoomSpring.animationTime = 2;
  //   //  调整左上角坐标及区域图宽高，避免标注区域占满整个页面
  //   let arr = data.position.split(',');
  //   const viewRect = this.viewer.viewport.imageToViewportRectangle(
  //     new OpenSeadragon.Rect(
  //       parseFloat(arr[0]) - 600,
  //       parseFloat(arr[1]) - 600,
  //       parseFloat($('.markDetail').width()) + 1200,
  //       parseFloat($('.markDetail').height()) + 1200
  //     )
  //   );
  //   //  将当前标注所在位置移动至中心处,并放大图片
  //   this.viewer.viewport.fitBoundsWithConstraints(viewRect);

  //   // 获取标注详情
  //   $('#markAudio')[0].pause();
  //   this.audioEnded = true;
  //   this.loadMarkDetail(data, overlayEle);
  // }

  // 根据矩形左上角坐标及宽高获取四个点
  getPoints(x, y, w, h) {
    return [{
        x: x,
        y: y
      },
      {
        x: x + w,
        y: y
      },
      {
        x: x + w,
        y: y + h
      },
      {
        x: x,
        y: y + h
      }
    ];
  }

  // 清除高亮区域
  clearHighlight(){
    let th = this;
    this.viewer.viewport.fitVertically();
    // // 设置缩放动画时间
    // th.viewer.viewport.zoomSpring.animationTime = 5;
    // // 调整左上角坐标及区域图宽高，避免标注区域占满整个页面
    // let markDetail = th.allMarksList.filter((item) => item.imageMarkId === th.markId)[0];
    // const viewRect = th.viewer.viewport.imageToViewportRectangle(
    //   new OpenSeadragon.Rect(
    //     parseFloat(markDetail.position.split(',')[0]),
    //     parseFloat(markDetail.position.split(',')[0]),
    //     parseFloat(markDetail.width),
    //     parseFloat(markDetail.width)
    //   ),
    // );
    // // 将当前标注所在位置移动至中心处,并放大图片
    // th.viewer.viewport.fitBoundsWithConstraints(viewRect);
		this.markClick('',null)
  }

  // 绘制高亮区域
	markClick(id, overlayEle){
    this.markId = id;
		let delayTime = 0;
		if(id){
      let data = this.allMarksList.filter((item) => item.imageMarkId === id)[0];
      $('.markOverlay').css('display','none');
      $('.markActive').css('display','block');
			const rect = {
        x: parseFloat(data.position.split(',')[0]),
        y: parseFloat(data.position.split(',')[1]),
        cx: parseFloat(data.point.split(',')[0]),
        cy: parseFloat(data.point.split(',')[1]),
        width: parseFloat(data.width),
        height: parseFloat(data.height),
        text: data.markName,
        id: data.imageMarkId
      };
      this.loadMarkDetail(data, overlayEle);
			// // 获取标注详情
      // setTimeout(()=>{
      //   this.loadMarkDetail(data, overlayEle);
      // },1000);
			
			// 设置缩放动画时间
			this.viewer.viewport.zoomSpring.animationTime = 10;
			this.viewer.viewport.centerSpringX.animationTime = 10;
			this.viewer.viewport.centerSpringY.animationTime = 10;
      // // 获取选中标注的x,y,width,height，创建矩形对象，并从以像素坐标描述图像的一部分的矩形转换为 OpenSeadragon 视口矩形坐标
			// const viewRect = this.viewer.viewport.imageToViewportRectangle(
			// 	new OpenSeadragon.Rect(
			// 		rect.x,
      //     rect.y,
			// 		rect.width,
			// 		rect.height
			// 	),
			// );
			// // 使视口缩放和平移，以便指定的边界在视口中占用尽可能多的空间，同时强制执行约束（minZoom、maxZoom 和 visibilityRatio）
      // // fitBounds则选中的标记矩形框会占满整个显示区域
			// this.viewer.viewport.fitBoundsWithConstraints(viewRect);
      const point1 = this.viewer.viewport.imageToViewportCoordinates(
        new OpenSeadragon.Point( 
        rect.x+rect.width/2,
        rect.y+rect.height/2
      ));
      // 将视野中心移动至指定坐标点位置
      this.viewer.viewport.panTo(point1,false);
      // 根据标记区域的宽高，估算需放大的倍数；
      const zoomVal = this.getZoomVal(data.width,data.height);
      this.viewer.viewport.zoomTo(zoomVal);
			delayTime = 2000;
		}
		
		// 标注区域高亮
		setTimeout(() => {
			// 绘制或清除高亮区域
      let that = this;
			this.overlay = this.viewer.canvasOverlay({
				onRedraw:function() {
					let ctx = that.overlay.context2d();
					let segmentsArr = [];
					if(that.markId){
            let data = that.allMarksList.filter((item) => item.imageMarkId === that.markId)[0];
					  // segmentsArr = that.transformPoints(data.points);
            segmentsArr = data.points;
						// // 绘制标记区域
						// ctx.beginPath();
						// ctx.moveTo(segmentsArr[0].x,segmentsArr[0].y);
						// for(let i = 1;i<segmentsArr.length;i++){
						// 	ctx.lineTo(segmentsArr[i].x,segmentsArr[i].y);
						// }
						// ctx.closePath(); 
						// ctx.fill();
						// ctx.globalCompositeOperation="source-out";
						// // 绘制黑色蒙版
						// ctx.fillStyle = 'rgba(0,0,0,0.75)';
						// ctx.fillRect(0,0,that.viewer.source.width,that.viewer.source.height);
            // ctx.save();
						// ctx.globalCompositeOperation="source-over";
						// // 绘制描边
						// ctx.strokeStyle = "rgb(249,239,184)";
						// ctx.lineWidth = 1;
            // ctx.lineCap = 'round';
            // ctx.lineJoin = 'round';
						// ctx.beginPath();
						// ctx.moveTo(segmentsArr[0].x,segmentsArr[0].y);
						// for(let i = 1;i<segmentsArr.length;i++){
						// 	ctx.lineTo(segmentsArr[i].x,segmentsArr[i].y);
						// }
						// ctx.closePath(); 
            // ctx.shadowColor = 'rgb(244,206,6)';
            // ctx.shadowBlur = 16;
						// ctx.stroke();
            // ctx.restore();

            // 绘制标记区域
						ctx.beginPath();
						ctx.moveTo(segmentsArr[0].x,segmentsArr[0].y);
						for(let i = 1;i<segmentsArr.length;i++){
							ctx.lineTo(segmentsArr[i].x,segmentsArr[i].y);
						}
						ctx.closePath(); 
            ctx.globalAlpha = 0.6;
            ctx.shadowColor = 'rgb(255,255,255)';
            ctx.shadowBlur = 12;
						ctx.fill();
						ctx.globalCompositeOperation="xor";
						// 绘制黑色蒙版
						ctx.fillStyle = 'rgb(0,0,0)';
            ctx.shadowBlur = 0;
            ctx.globalAlpha = 0.9;
						ctx.fillRect(0,0,that.viewer.source.width,that.viewer.source.height);
            // ctx.save();
						// ctx.globalCompositeOperation="source-over";
            // // 绘制标记区域
						// ctx.beginPath();
						// ctx.moveTo(segmentsArr[0].x,segmentsArr[0].y);
						// for(let i = 1;i<segmentsArr.length;i++){
						// 	ctx.lineTo(segmentsArr[i].x,segmentsArr[i].y);
						// }
						// ctx.closePath(); 
						// ctx.fillStyle = 'rgba(0,0,0,0)';
						// ctx.fill();
						// ctx.restore();
            // ctx.save();
						// ctx.globalCompositeOperation="source-over";
						// // 绘制描边
						// ctx.strokeStyle = "rgb(249,239,184)";
						// ctx.lineWidth = 1;
            // ctx.lineCap = 'round';
            // ctx.lineJoin = 'round';
						// ctx.beginPath();
						// ctx.moveTo(segmentsArr[0].x,segmentsArr[0].y);
						// for(let i = 1;i<segmentsArr.length;i++){
						// 	ctx.lineTo(segmentsArr[i].x,segmentsArr[i].y);
						// }
						// ctx.closePath(); 
            // ctx.shadowColor = 'rgb(244,206,6)';
            // ctx.shadowBlur = 16;
						// ctx.stroke();
            // ctx.restore();
					}else{
						// 移除黑色蒙版
						ctx.clearRect(0,0,that.viewer.source.width,that.viewer.source.height);
					}
				},
				clearBeforeRedraw:true
			});
		},delayTime);
	
    let th = this;
		window.onresize = function(){
			th.overlay.resize();
		}
	}

  // 根据标记区域的宽高，估算需放大的倍数；
  getZoomVal(width,height){
    let zoomVal = 2;
    if(width < 60){
      if(width<30 && height<30){
        zoomVal = 6;
      }else{
        if(height < 60){
          zoomVal = 4;
        }else if(height < 100){
          zoomVal = 3;
        }else if(height < 250){
          zoomVal = 2;
        }else if(height < 500){
          zoomVal = 1.6;
        }else if(height < 1000){
          zoomVal = 1.4;
        }else{
          zoomVal = 1.2;
        }
      }
    }else if(width >= 60 && width < 250){
      if(height < 60){
        zoomVal = 3;
      }else if(height < 100){
        zoomVal = 2.6;
      }else if(height < 250){
        zoomVal = 2;
      }else if(height < 500){
        zoomVal = 1.6;
      }else if(height < 1000){
        zoomVal = 1.4;
      }else{
        zoomVal = 1.2;
      }
    }else if(width < 500){
      zoomVal = 1.6;
    }else if(width < 1000){
      zoomVal = 1.4;
    }else{
      zoomVal = 1.2;
    }
    console.log(width,height,zoomVal);
    return zoomVal;
  }

  // 将所有的相邻的两个描点作为一组，计算两点之间的弧线上指定数量的点的坐标
  transformPoints(points){
    let res = [];
    for(let i=0;i<points.length-1;i++){
      let start = points[i];
      let end = points[i+1];
      let arr = this.getPointsByStartAndEnd(start.x,start.y,end.x,end.y,20,100);
      res = res.concat(arr);
    }
    console.log(res)
    return res;
  }

  // 计算出这两点之间的弧线上指定数量的点的坐标
  getPointsByStartAndEnd(x1,y1,x2,y2,pointCount,level){
    let a,b,rSquare,k,kv,points=[];
    if(x1===x2){
      a = x1+(y2-y1)*level;
      b = y1+(y2-y1)/2;
      rSquare = (x1 - a) ** 2 + (y1 - b) ** 2;
    }else if(y1 == y2){
      a = x1+(x2-x1)/2;
      b = y1+(x2-x1)*level;
      rSquare = (x1 - a) ** 2 + (y1 - b) ** 2;
    }else{
      let xc = (x1 + x2) / 2, yc = (y1 + y2)/2;
      let lenSquare = ((x2-x1) ** 2) + ((y2-y1) ** 2) * (level ** 2);
      k = (x2-x1)/(y1-y2);
      let l = yc - k*xc;
      let a1 = 1 + k**2, b1 = 2*k*(l -yc) - 2*xc, c1 = xc**2 + (l-yc)**2 - lenSquare;
      kv = -1/k;
      a = (-b1 + Math.sqrt(b1**2 - 4*a1*c1)*((kv>0 && x2>x1 || kv<0 && x2<x1) ? 1 : -1))/(2*a1);
      b = k*a + l;
      rSquare = (x1-a)**2 + (y1-b)**2;
    }
    if(x1 === x2 || Math.abs(kv)>1){
      let yDistance = y2-y1;
      let yDis = yDistance/(pointCount+1);
      for(let i=0;i<pointCount;i++){
        let y = y1+yDis*(i+1);
        let x = Math.sqrt(rSquare - (y-b)**2)*(y2>y1 ? -1 : 1)+a;
        points.push({x:x,y:y});
      }
    }else{
      let xDistance = x2-x1;
      let xDis = xDistance/(pointCount+1);
      for(let i=0;i<pointCount;i++){
        let x = x1+xDis*(i+1);
        let y = Math.sqrt(rSquare - (x-a)**2)*(x2>x1 ? 1 : -1)+b;
        points.push({x:x,y:y});
      }
    }
    return points
  }

  // 加载标记详情
  loadMarkDetail(markDetail, overlayEle) {
    // 加载相同元素数据
    this.loadSameElements(markDetail);

    // 加载知识扩展
    if (markDetail.instances.length < 1) {
      $('.knowledgebox2').css('display', 'none');
    }else{
      $('.knowledgebox2').css('display', 'block');
    }
    if (markDetail.instances.length > 0) {
      this.markpage = 0;
      $('.knowledgeitem2 .prev').addClass('disable');
      $('.knowledgeitem2 .next').removeClass('disable');
      let item = '';
      for (let i = 0; i < markDetail.instances.length; i++) {
        item += `<div class="item">
        <a href="${window.location.href.split('/')[0]}/Subject/${this.conceptCode ? this.conceptCode : 'null'}/${markDetail.instances[i].instanceId}" target="_blank" class="imgbox">
        ${
          markDetail.instances[i].showImage
            ? `<img src="${window.ENV_IMG_PREURL_SRC}/${markDetail.instances[i].showImage}" alt=""  class="img" />`
            : ''
        }
        </a>
        <div class="title">${markDetail.instances[i].instanceName}</div>
      </div>`;
      }
      $('.markData .wrap2').html(item);
    }
    if (markDetail.instances.length <= 3) {
      $('.knowledgeitem2 .slick-arrow').css('display', 'none');
    }else{
      $('.knowledgeitem2 .slick-arrow').css('display', 'block');
    }

    // 加载标记基础信息
    $('.markData h3').text(markDetail.markName);
    if (markDetail.markNote) {
      $('.markData p').text(markDetail.markNote);
    }else{
      $('.markData p').text('');
    }
    if (markDetail.markNoteAudio) {
      $('.markData .bottomBtns').html(
        '<i class="fa fa-volume-down play" id="playAudio" aria-hidden="true"></i>'
      );
      const audioUrl = window.ENV_IMG_PREURL_SRC + markDetail.markNoteAudio;
      $('#markAudio').attr('src', audioUrl);
      //  播放/暂停音频
      $('#playAudio').on('click', function() {
        if ($(this).hasClass('play')) {
          $(this)
            .removeClass('play fa-volume-down')
            .addClass('fa-volume-off');
          $('#markAudio')[0].pause();
          this.audioEnded = true;
        } else {
          $(this)
            .addClass('play fa-volume-down')
            .removeClass('fa-volume-off');
          $('#markAudio')[0].play();
          this.audioEnded = false;
        }
      });
    }
    $('.markDetail').fadeIn();
    // setTimeout(() => {
    //   //  获取定位坐标
    //   let obj = {
    //     top: this.getStr(overlayEle.css('top')),
    //     left: this.getStr(overlayEle.css('left')),
    //     width: this.getStr(overlayEle.css('width')),
    //     height: this.getStr(overlayEle.css('height'))
    //   };
    //   let top = obj.top + obj.height / 2 + 30;
    //   let left = obj.left + obj.width / 2;
    //   //  获取页面宽高
    //   let pageW = $('#pic').width();
    //   let pageH = $('#pic').height();
    //   let elW = $('.markDetail').width();
    //   let elH = $('.markDetail').height();
    //   //  当标记详情弹框的定位坐标超出页面时，调整坐标
    //   if (top + elH > pageH) {
    //     top = pageH - elH - 10;
    //   }
    //   if (left + elW > pageW) {
    //     left = pageW - elW - 10;
    //   }
    //   $('.markDetail')
    //     .css('top', top)
    //     .css('left', left);
    //   $('.markDetail').fadeIn();
    //   if (markDetail.markNoteAudio) {
    //     $('#markAudio')[0].play();
    //     this.audioEnded = false;
    //   }
    // }, 1000);
  }

  // 加载相同元素数据
  loadSameElements(markDetail){
    if(this.currentMarkId == markDetail.imageMarkId){
      return;
    }else{
      this.currentMarkId = markDetail.imageMarkId;
    }
    querySameElementFileList({
      current: 1,
      size: 30,
      imageMarkId: markDetail.imageMarkId,
      imageMarkName: markDetail.markName
    }).then((res) => {
      if (res.records < 1) {
        $('.knowledgebox1').css('display', 'none');
      }else{
        $('.knowledgebox1').css('display', 'block');
      }
      res.records.forEach(el => {
        // el['imgUrl'] = iiifPre+el.instances[0].showImage.replace(/\/\//g, '/').replace(/\//g, '%2F')+'/'+ el.position + ',' + el.width + ',' + el.height + '/full/0/default.png';
        el['imgUrl'] = imgPre+'/'+el.fileInfoList[0].filePath;
        el['path'] = window.location.href.split('/')[0] + '/PicturelistPage/'+el.instances[0].instanceId+'?fileInfoId='+el.fileInfoId+'&hasMark=1';
      })
      if (res.records.length > 0) {
        this.markpage1 = 0;
        $('.knowledgeitem1 .prev').addClass('disable');
        $('.knowledgeitem1 .next').removeClass('disable');
        let item = '';
        for (let i = 0; i < res.records.length; i++) {
          item += `<div class="item">
          <a href="${res.records[i]['path']}" target="_blank" class="imgbox">
          ${`<img src="${res.records[i]['imgUrl']}" alt=""  class="img" />`}
          </a>
          <div class="title">${res.records[i].instances[0].instanceName}</div>
        </div>`;
        }
        $('.markData .wrap1').html(item);
      }
      if (res.records.length <= 3) {
        $('.knowledgeitem1 .slick-arrow').css('display', 'none');
      }else{
        $('.knowledgeitem1 .slick-arrow').css('display', 'block');
      }
    });
  }

  //  将获取的值变成数字类型 例如：123.2px
  getStr(str) {
    let str1 = str.substring(0, str.length - 2);
    return parseFloat(str1);
  }

  //  查询图片所属实例
  getInstanceDetail() {
    queryInstanceDetails({
      attrEnglishCodes: [],
      instanceId: this.instanceId
    }).then((res) => {
      //  加载实例信息
      this.conceptCode = res.conceptCode;
      const th = this;
      this.loadInstanceInfo(res, th);
      if (res) {
        // 实例详情
        this.instanceData = res;
        // 加载推荐实例数据
        this.getRecommendInstance(1);
      }
    });
  }

  //  加载图片详情弹框
  loadInstanceInfo(data) {
    this.conceptCode = data.conceptCode;
    let html = ` <h1 class="culture_name">${data.instanceName || '不详'}</h1>
    <div class="culture_basic">
      <h2 class="culture_title">
        <span class="arrow_down">
          <i class="iconfont icon-jiantouxia" aria-hidden="true" />
        </span>
        基本信息
      </h2>
      <div class="culture_content">
        <p class="culture_info">
          <span class="name">正名：</span>
          <span class="value">${data.properties.title || data.properties.name || '不详'}</span>
        </p>
        <p class="culture_info">
          <span class="name">别名：</span>
          <span class="value">${data.properties.alias || '不详'}</span>
        </p>
        <p class="culture_info">
          <span class="name">类型：</span>
          <span class="value">${data.properties.type || '不详'}</span>
        </p>
        <p class="culture_info">
          <span class="name">材质：</span>
          <span class="value">${data.properties.material || '不详'}</span>
        </p>
        <p class="culture_info">
          <span class="name">地点：</span>
          <span class="value">${data.properties.currentLocation || '不详'}</span>
        </p>
        <p class="culture_info">
          <span class="name">创建人：</span>
          <span class="value">${data.properties.creator || '不详'}</span>
        </p>
        <p class="culture_info">
          <span class="name">年代：</span>
          <span class="value">${data.properties.creationDate || '不详'}</span>
        </p>
      </div>
    </div>

    <div class="culture_basic">
      <h2 class="culture_title">
        <span class="arrow_down">
          <i class="iconfont icon-jiantouxia" aria-hidden="true" />
        </span>
        描述
      </h2>
      <div class="culture_content">
        <div class="culture_intro">
        ${data.properties.description || '不详'}
        </div>
      </div>
    </div>`;
    $('#picture_info').html(html);

    //  图片详情：基本信息、多媒体资源信息折叠和展示
    $('.culture_title').on('click', function() {
      let parent = $(this).parent();
      let iEl = $(this).find('i');
      if (parent.hasClass('culture_basic')) {
        if (iEl.hasClass('icon-jiantouxia')) {
          iEl.removeClass('icon-jiantouxia').addClass('icon-jiantoushang');
          parent.find('.culture_content').slideUp();
        } else {
          iEl.removeClass('icon-jiantoushang').addClass('icon-jiantouxia');
          parent.find('.culture_content').slideDown();
        }
      } else {
        if (iEl.hasClass('icon-jiantouxia')) {
          iEl.removeClass('icon-jiantouxia').addClass('icon-jiantoushang');
          parent.find('.culture_video_wrapper').slideUp();
        } else {
          iEl.removeClass('icon-jiantoushang').addClass('icon-jiantouxia');
          parent.find('.culture_video_wrapper').slideDown();
        }
      }
    });
  }

  //  查询推荐实例信息
  getRecommendInstance(currentPage) {
    queryRecommendedImageList({
      conceptCodes: [this.instanceData.conceptCode],
      current: currentPage,
      instanceId: this.instanceData.instanceId,
      instanceName: this.instanceData.instanceName,
      size: 3
    }).then((res) => {
      this.current = currentPage;
      this.currentShow = this.current;
      this.tuijianpages = res.pages;
      if (res?.total === 0) {
        // 如果没有数据相关推荐隐藏
        $('.img_info #relative').hide();
      } else {
        $('.img_info #relative').show();
      }
      if (res?.records) {
        this.recommendData = this.recommendData.concat(res.records);
        this.loadRecommendInstance(res.records);
      }
    });
    // let queryParams = {
    //   current: currentPage,
    //   size: 3,
    //   params: {
    //     conceptCode: conceptCode
    //   }
    // };
    // $.ajax({
    //   type: 'post',
    //   url: platformUrlOther + 'apiInstance/findRecommendInstance',
    //   data: JSON.stringify(queryParams),
    //   dataType: 'json',
    //   contentType: 'application/json',
    //   success: function(data) {
    //     if (data.code == '200') {
    //       if (data.data) {
    //         current = currentPage;
    //         currentShow = current;
    //         recommendData = recommendData.concat(data.data);
    //         loadRecommendInstance(data.data);
    //       }
    //     } else {
    //       console.log(data.msg);
    //     }
    //   },
    //   error: function() {
    //     console.log('服务器异常，请稍后再试！');
    //   }
    // });
  }

  //  加载推荐实例数据
  loadRecommendInstance(data) {
    let html = '';
    for (let i = 0; i < data.length; i++) {
      html +=
        '<div class="relativeCultureBox" data-id="' +
        data[i].instanceId +
        '" data-type="' +
        data[i].conceptCode +
        '">';
      // if (data[i].showImage) {
      // html +=
      //   '<img src="' +
      //   (data[i].showImage ? window.ENV_IMG_PREURL_SRC + '/' + data[i].showImage : '') +
      //   '" alt="暂无图片" title=' +
      //   data[i].instanceName +
      //   '>';
      html += `<a href="${window.location.href.split('/')[0]}/Subject/${data[i].conceptCode}/${
        data[i].instanceId
      }" target="_blank" class='imgbox'>
          <img src="${
            data[i].showImage ? window.ENV_IMG_PREURL_SRC + '/' + data[i].showImage : defaultimg
          }" alt="暂无图片">
          </a>
          <p>${data[i].instanceName}</p>'`;
      // }
      html += '</div>';
    }
    $('.relativeSlideContent').append(html);
    if (this.current > 1) {
      let containerWidth = $('.relativeSlideContent').width();
      let elements = $('.relativeCultureBox');
      for (let i = elements.length - 3; i < elements.length; i++) {
        let translateX = this.getTransformVal(elements.eq(0))[4];
        elements.eq(i).css('transform', 'translateX(' + translateX + 'px)');
      }
      setTimeout(() => {
        for (let i = 0; i < elements.length; i++) {
          let translateX = this.getTransformVal(elements.eq(0))[4];
          elements.eq(i).css('transform', 'translateX(' + (translateX - containerWidth) + 'px)');
        }
      }, 500);
      $('.relativeSlideLeft').removeClass('disable');
    }

    $('.relativeCultureBox').on('click', function() {
      console.log('relativeCultureBox');
      // let instanceId = $(this).attr('data-id');
      // let concetpCode = $(this).attr('data-type');
      // let url = addressUrl(conceptCode, instanceId);
      // window.open(url);
    });
  }

  // //  根据取点绘制面
  // function drawSurface(type) {
  //   drawType = type;
  //   overlay = viewer.canvasOverlay({
  //     onRedraw: function() {
  //       let ctx = overlay.context2d();
  //       if (drawType == 'empty') {
  //         ctx.clearRect(0, 0, viewer.source.width, viewer.source.height);
  //         return;
  //       }

  //       if (drawType == 'surface' && clickPointArr.length >= 3) {
  //         //  绘制所有点组成的面
  //         ctx.fillStyle = 'rgba(95,162,250,0.3)';
  //         ctx.beginPath();
  //         ctx.moveTo(clickPointArr[0].x, clickPointArr[0].y);
  //         for (let j = 1; j < clickPointArr.length; j++) {
  //           ctx.lineTo(clickPointArr[j].x, clickPointArr[j].y);
  //         }
  //         ctx.closePath();
  //         ctx.fill();

  //         //  绘制起始点与结束点之间的连线
  //         const firstPoint = clickPointArr[0];
  //         const lastPoint = clickPointArr[clickPointArr.length - 1];
  //         ctx.strokeStyle = '#4DA0FB';
  //         ctx.lineWidth = 5;
  //         ctx.setLineDash([20, 20]);
  //         ctx.beginPath();
  //         ctx.moveTo(lastPoint.x, lastPoint.y);
  //         ctx.lineTo(firstPoint.x, firstPoint.y);
  //         ctx.closePath();
  //         ctx.stroke();
  //       }
  //       //  绘制连线
  //       ctx.strokeStyle = '#4DA0FB';
  //       ctx.lineWidth = 5;
  //       ctx.setLineDash([20, 20]);
  //       for (let i = 0; i < clickPointArr.length; i++) {
  //         let point = clickPointArr[i];
  //         //  绘制当前点与上一个点之间的连线
  //         if (i > 0) {
  //           const prevPoint = clickPointArr[i - 1];
  //           ctx.beginPath();
  //           ctx.moveTo(prevPoint.x, prevPoint.y);
  //           ctx.lineTo(point.x, point.y);
  //           ctx.closePath();
  //           ctx.stroke();
  //         }
  //       }
  //       //  绘制点
  //       for (let i = 0; i < clickPointArr.length; i++) {
  //         let point = clickPointArr[i];
  //         //  绘制圆环
  //         //  绘制外圈圆
  //         ctx.beginPath();
  //         ctx.fillStyle = '#4DA0FB';
  //         ctx.arc(point.x, point.y, 24, 0, 2 * Math.PI);
  //         ctx.closePath();
  //         ctx.fill();
  //         //  绘制内圈圆
  //         ctx.beginPath();
  //         ctx.fillStyle = '#ffffff';
  //         ctx.arc(point.x, point.y, 18, 0, 2 * Math.PI);
  //         ctx.closePath();
  //         ctx.fill();
  //       }
  //     },
  //     clearBeforeRedraw: true
  //   });
  //   setTimeout(function() {
  //     const zoom = viewer.viewport.getZoom();
  //     viewer.viewport.zoomTo(zoom + 0.000001);
  //     //  绘面完成后需需绘制清除按钮，并添加点击事件
  //     if (drawType == 'surface') {
  //       //  绘制清除按钮
  //       drawRemoveBtn(getRectPoint(clickPointArr));
  //     }
  //   }, 500);
  //   window.onresize = function() {
  //     overlay.resize();
  //   };
  // }

  // //  绘制清除按钮
  // function drawRemoveBtn(rect) {
  //   //  id必须为唯一，否则移除后再添加新的图层时位置不会改变
  //   const id = 'remove_' + rect.x;
  //   let domElement = document.createElement('div');
  //   domElement.id = id;
  //   let ele = {
  //     id: id,
  //     element: domElement,
  //     x: rect.midX,
  //     y: rect.midY,
  //     width: rect.w / 2,
  //     height: rect.h / 2
  //   };
  //   hEl.addElement(ele);
  //   let divEle = hEl.getElementById(id).element;
  //   divEle.innerHTML =
  //     '<div id="removeSurBtn">' +
  //     '<span>清除</span>' +
  //     '<img src="../../../img/icon-trash.png"/>' +
  //     '</div>';

  //   // 给绘制完成的清除按钮绑定点击事件
  //   divEle.onclick = function() {
  //     hEl.removeElementById(id);
  //     drawSurface('empty');
  //     hasDrawed = false;
  //     clickPointArr = [];
  //     $('.openseadragon-canvas').css('cursor', 'crosshair');
  //   };
  // }

  // //  根据概念的不同跳转至不同的详情页面
  // function addressUrl(type, urlId) {
  //   let urlAddress = '';
  //   if (type == 'person') {
  //     urlAddress = '../../knowledgeMap/demo/detailPerson.html?id=' + urlId + '&type=1';
  //   } else if (
  //     type == 'inscription' ||
  //     type == 'seal' ||
  //     type == 'postscript' ||
  //     type == 'publication'
  //   ) {
  //     urlAddress = '../../knowledgeMap/demo/detailOther.html?id=' + urlId + '&type=1';
  //   } else if (type == 'group') {
  //     urlAddress = '../../knowledgeMap/demo/detailGroup.html?id=' + urlId + '&type=1';
  //   } else if (type == 'place' || type == 'exhibition' || type == 'official_system') {
  //     urlAddress = '../../knowledgeMap/demo/detailPlace.html?id=' + urlId + '&type=1';
  //   } else if (type == 'post') {
  //     urlAddress = '../../knowledgeMap/demo/detailPost.html?id=' + urlId + '&type=1';
  //   } else if (type == 'historical_event') {
  //     urlAddress = '../../knowledgeMap/demo/detailHistoricalevent.html?id=' + urlId + '&type=1';
  //   } else if (type == 'painting' || type == 'calligraphy') {
  //     urlAddress = '../../knowledgeMap/demo/detailPainting.html?id=' + urlId + '&type=1';
  //   } else {
  //     urlAddress = '../../knowledgeMap/demo/detailCalligraphy.html?id=' + urlId + '&type=1';
  //   }
  //   return urlAddress;
  // }
}
// $(function() {

// });
export default PictureViewer;
